//Animation flexible content bloc tabs
const onglets = document.querySelectorAll('.bloc-tabs__tab');
const contenu = document.querySelectorAll('.bloc-tabs__content')
let index = 1;

onglets.forEach(onglet => {
    let hauteurEnfant = document.querySelector(".bloc-tabs__content--active").offsetHeight;
    document.querySelector(".bloc-tabs__panel").style.height = hauteurEnfant+'px';

    onglet.addEventListener('click', () => {

        if(onglet.classList.contains('bloc-tabs__tab--active')){
            return;
        } else {
            onglet.classList.add('bloc-tabs__tab--active');
        }

        index = onglet.getAttribute('tabindex');
        
        for(let i = 0; i < onglets.length; i++) {
            if(onglets[i].getAttribute('tabindex') != index) {
                onglets[i].classList.remove('bloc-tabs__tab--active');
            }
        }

        for(let j = 0; j < contenu.length; j++){
            if(contenu[j].getAttribute('tabindex') == index) {
                contenu[j].classList.add('bloc-tabs__content--active');
            } else {
                contenu[j].classList.remove('bloc-tabs__content--active');
            }
        }

        let hauteurEnfant = document.querySelector(".bloc-tabs__content--active").offsetHeight;
        document.querySelector(".bloc-tabs__panel").style.height = hauteurEnfant+'px';

    })

}) 